import React from 'react';
import PropTypes from 'prop-types';
import { Box } from 'rebass/styled-components';
import styled from 'styled-components';
import theme from 'styled-theming';

const headingColor = theme('mode', {
  light: (props) => props.theme.colors.deepGrey,
  dark: (props) => props.theme.colors.white,
});

const HeadingWrapper = styled(Box)`
  line-height: 1.2;
  color: ${headingColor};
`;

function Heading(props) {
  const { children, ...otherProps } = props;
  return (
    <Box mb={2} {...otherProps}>
      <HeadingWrapper fontSize={4} fontWeight={400} mr={2}>
        {children}
      </HeadingWrapper>
    </Box>
  );
}

Heading.defaultProps = {};

Heading.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Heading;
